export default __webpack_public_path__ + "static/media/logo_smartplasticsurgery.4b88d7ea.png";